import { Routes, RouterModule } from '@angular/router';
import { HisAuthGuard, HisBootstrapService } from 'hisng';
import { ErpStartpageComponent } from './erp-startpage.component';

export const ROUTE_CONFIG: Routes = [
    {
        path: 'workflow',
        loadChildren: () => import( './rm/erp/common/workflow/erpworkflow-core.module' ).then( m => m.ErpWorkflowCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            modules: ['HISINONEZEB']
        }
    },
    {
        path: 'timemanagement',
        loadChildren: () => import( './rm/erp/timemanagement/timemanagement-core.module' ).then( m => m.TimeManagementCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            modules: ['HISINONEZEB']
        }
    },
    {
        path: 'jobapplication',
        loadChildren: () => import( './rm/erp/jobapplication/jobapplication-core.module' ).then( m => m.JobApplicationCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            modules: ['HISINONEBWM']
        }
    },
    {
        path: 'jobadvertisement',
        loadChildren: () => import( './rm/erp/jobadvertisement/jobadvertisement-core.module' ).then( m => m.JobAdvertisementCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            modules: ['HISINONEBWM']
        }
    },
    {
        path: 'businesstripapplication',
        loadChildren: () => import( './rm/erp/travelmanagement/businesstripapplication/businesstripapplication-core.module' ).then( m => m.BusinesstripApplicationManagementCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            modules: ['HISINONERKA']
        }
    },
    {
        path: '',
        pathMatch: 'full',
        component: ErpStartpageComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_EVERYONE']
        },
        resolve: { boot: HisBootstrapService },
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppRoutesModule = RouterModule.forRoot( ROUTE_CONFIG, {} );
